/* global System */
// register component(s) with react habitat

export default {
  VideoStage: () =>
    System.import(
      /* webpackChunkName: "VideoStage" */
      './Component'
    ),
}
